import React from 'react';
import { Link as RouterLink, Navigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
    Box,
    Button,
    Container,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import {
    BLOG_BASE_URL,
    blogPostBySlug,
    getBlogPostStructuredData,
    getBlogPostUrl,
} from './blog/blogPosts';
import {
    BlogArticle,
    BlogHeader,
    BlogSidebar,
} from './blog/BlogLayout';
import SiteFooter, { FooterCta } from '../components/landing/SiteFooter';

function BlogPostPage() {
    const { slug = '' } = useParams();
    const post = blogPostBySlug[slug];

    if (!post) {
        return <Navigate to="/404/" replace />;
    }

    const canonicalUrl = getBlogPostUrl(post);
    const structuredData = getBlogPostStructuredData(post);
    const handleRegisterClick = () => {
        window.location.href = '/vhod/';
    };

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
            <Helmet defer={false}>
                <title>{post.title} | ФинРадар</title>
                <meta name="description" content={post.description} />
                <meta name="keywords" content={post.keywords} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={`${post.title} | ФинРадар`} />
                <meta property="og:description" content={post.description} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:image" content={`${BLOG_BASE_URL}${post.heroImage.src}`} />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>

            <BlogHeader />

            <Container maxWidth="xl" sx={{ py: { xs: 4, md: 7 } }}>
                <Button
                    component={RouterLink}
                    to="/blog/"
                    startIcon={<ArrowBackRoundedIcon />}
                    sx={{ mb: 3, color: '#475467', textTransform: 'none', fontWeight: 800 }}
                >
                    Все статьи
                </Button>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', lg: '280px minmax(0, 980px)' },
                        gap: { xs: 3, lg: 4 },
                        alignItems: 'start',
                    }}
                >
                    <BlogSidebar post={post} />
                    <BlogArticle post={post} />
                </Box>
            </Container>

            <FooterCta onRegisterClick={handleRegisterClick} />
            <SiteFooter onRegisterClick={handleRegisterClick} />
        </Box>
    );
}

export default BlogPostPage;
